import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import locale from 'element-ui/lib/locale/lang/en';//多语言支持
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'

import '@/styles/index.css'; // global css

import App from './App.vue';
import store from './store';
import router from './router';

// set ElementUI lang to EN
//Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI);
Vue.use(VxeUIAll)
Vue.use(VXETable);
Vue.config.productionTip = false;
Vue.prototype.$XModal = VXETable.modal;

Array.prototype.indexOf = function (val) {
    for (let i = 0; i < this.length; i++) {
        if (this[i] === val) return i;
    }
    return -1;
};
Array.prototype.remove = function (val) {
    let index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
